import React from 'react';
import ErrorPage500 from "../../images/page500.svg";
import {useNavigate} from "react-router-dom";
import {setAutoRedirect} from "../../redux-store/auth";
import {useDispatch} from "react-redux";

const Page500 = () => {
    const dispatch = useDispatch();

    let navigate = useNavigate();
    const goBack = () => {
        dispatch(setAutoRedirect(null));
        setTimeout(()=>{
            navigate("/");
        },[500])
    }
    return (
        <>
            <div className={"container-fluid text-center error-page"}>
                <div className={"row pt-5"}>
                    <div className={"col-12 col-md-12 col-lg-12 col-xl-12 pt-5 error-page-image bcg-white"}>
                        <img src={ErrorPage500}/>
                    </div>
                    <div className={"col-12 col-md-12 col-lg-12 col-xl-12 error-page-number bcg-white"}>
                        <span>500</span>
                    </div>
                    <div className={"col-12 col-md-12 col-lg-12 col-xl-12 error-page-message bcg-white"}>
                        <p>Servis je nedostupan. Server je trenutno preopterećen, molimo vas da pokušate opet malo kasnije!</p>
                    </div>
                    <div className={"col-12 col-md-12 col-lg-12 col-xl-12 error-page-message bcg-white"}>
                        <button className={"btn btn-back"} onClick={goBack}>Vrati se na početnu</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page500;
